import styled from '@emotion/styled';
import { useResource } from '@landsbankinn/l16n';
import * as React from 'react';
import NumberFormat from 'react-number-format';

export interface IProps {
  number?: number | null;
  decimalScale?: number;
  type: NumberType;
  displayPosNegColor?: boolean;
  isPositive?: boolean;
  displayISK?: boolean;
  hideZero?: boolean;
  hideNullIndicator?: boolean;
  suffix?: string;
  className?: string;
  style?: any;
}

const MarketsNumberFormat = styled(NumberFormat)`
  ${(props) =>
    props.showPosNeg && props.value !== 0
      ? props.isPositive ?? (props.value ?? 0) >= 0
        ? `color: ${props.theme.colors.positive}`
        : `color: ${props.theme.colors.negative}`
      : ''};
`;

export function MarketsFormatNumber({
  number,
  type,
  decimalScale,
  displayPosNegColor = false,
  isPositive,
  displayISK = false,
  hideZero = false,
  hideNullIndicator = false,
  suffix,
  className,
  ...rest
}: IProps) {
  const { locale } = useResource();
  const resolvedSuffix =
    type === NumberType.Percentage ? '%' : displayISK ? ' ISK' : suffix;
  return (
    <>
      {number !== null ? (
        !(number === 0 && hideZero) && (
          <MarketsNumberFormat
            value={
              type === NumberType.Percentage && number ? number * 100 : number
            }
            displayType="text"
            thousandSeparator={locale === 'is' ? '.' : ','}
            decimalSeparator={locale === 'is' ? ',' : '.'}
            fixedDecimalScale={true}
            decimalScale={decimalScale}
            suffix={resolvedSuffix}
            showPosNeg={displayPosNegColor}
            isPositive={isPositive}
            className={className}
            {...rest}
          />
        )
      ) : (
        <span className={className}>{hideNullIndicator ? '' : '-'} </span>
      )}
    </>
  );
}

interface IAmountProps {
  number?: number | null;
  displayPosNegColor?: boolean;
  currency?: string;
  className?: string;
}

export function MarketsFormatAmount({
  number,
  currency,
  ...rest
}: IAmountProps) {
  return (
    <MarketsFormatNumber
      number={number}
      type={NumberType.Number}
      suffix={` ${currency}`}
      decimalScale={currency === 'ISK' ? 0 : 2}
      {...rest}
    />
  );
}

export enum NumberType {
  Number,
  Percentage,
}
